import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=bb08d72e&scoped=true"
import script from "./candidates.ts?vue&type=script&lang=ts&external"
export * from "./candidates.ts?vue&type=script&lang=ts&external"
import style0 from "./Candidates.vue?vue&type=style&index=0&id=bb08d72e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb08d72e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb08d72e')) {
      api.createRecord('bb08d72e', component.options)
    } else {
      api.reload('bb08d72e', component.options)
    }
    module.hot.accept("./Candidates.vue?vue&type=template&id=bb08d72e&scoped=true", function () {
      api.rerender('bb08d72e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/client/candidates/Candidates.vue"
export default component.exports